<div>
  <div class="flex flex-col sm:flex-row sm:justify-between items-center">
    <form [formGroup]="searchForm" class="flex flex-col m-2 sm:flex-row">
      <mat-form-field>
        <mat-label>Search Vendors</mat-label>
        <input type="text" matInput formControlName="search" />
      </mat-form-field>
    </form>

    <button
      mat-raised-button
      (click)="goToVendorRegister()"
      color="accent"
      class="mr-5"
    >
      Create new Vendor
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="m-5">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      (matSortChange)="sortChange($event)"
      class="mat-elevation-z8"
      matTableResponsive
    >
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Name</th>
        <td mat-cell *matCellDef="let vendor">{{ vendor.name }}</td>
      </ng-container>

      <ng-container matColumnDef="User.FirstName">
        <th mat-header-cell *matHeaderCellDef>First Name</th>
        <td mat-cell *matCellDef="let vendor">{{ vendor.user?.firstName }}</td>
      </ng-container>

      <ng-container matColumnDef="User.LastName">
        <th mat-header-cell *matHeaderCellDef>Last Name</th>
        <td mat-cell *matCellDef="let vendor">{{ vendor.user?.lastName }}</td>
      </ng-container>

      <ng-container matColumnDef="User.Email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let vendor">
          {{ vendor.user?.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="User.UserProfile.Phone">
        <th mat-header-cell *matHeaderCellDef>Phone</th>
        <td mat-cell *matCellDef="let vendor">
          {{ vendor.user?.userProfile?.phone }}
        </td>
      </ng-container>

      <ng-container matColumnDef="studentAmbassador">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Student Ambassador
        </th>
        <td mat-cell *matCellDef="let vendor">
          {{ vendor.studentAmbassador }}
        </td>
      </ng-container>

      <ng-container matColumnDef="User.UserProfile.Street">
        <th mat-header-cell *matHeaderCellDef>Address</th>
        <td mat-cell *matCellDef="let vendor">
          @if(vendor.user && vendor.user.userProfile) {
          {{ vendor.user?.userProfile?.street }},
          {{ vendor.user?.userProfile?.city }},
          {{ vendor.user?.userProfile?.state }}
          {{ vendor.user?.userProfile?.zipCode }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let vendor">{{ vendor.status }}</td>
      </ng-container>

      <ng-container matColumnDef="manage">
        <th mat-header-cell *matHeaderCellDef>Manage</th>
        <td mat-cell *matCellDef="let vendor">
          <div class="flex-row">
            <button
              mat-mini-fab
              (click)="openEditDialog(vendor)"
              matTooltip="Edit"
              class="mr-2"
            >
              <mat-icon> edit </mat-icon>
            </button>
            <button
              mat-mini-fab
              (click)="openDeleteDialog(vendor)"
              matTooltip="Delete"
            >
              <mat-icon> delete </mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    [pageSizeOptions]="[5, 1, 20]"
    [length]="totalCount"
    showFirstLastButtons
    aria-label="Select page of vendors"
    (page)="changePage($event)"
  >
  </mat-paginator>
</div>
